import { defineComponent } from "@vue/composition-api";
import { CreateElement, RenderContext, VNode } from "vue";
import { ScopedSlotChildren } from "vue/types/vnode";
import { Location } from "vue-router";
import BaseMenu from "@/components/BaseMenu";
import BaseTitle from "@/components/BaseTitle";
import GoBack from "@/components/GoBack";

type Props = {
  hideBack: boolean;
  hideBorder: boolean;
  truncate: boolean;
  icon: string;
  pageMenu: boolean;
  defaultBack: Location;
};

export default defineComponent({
  name: "PageTitle",
  functional: true,
  props: {
    hideBack: { type: Boolean, default: false },
    hideBorder: { type: Boolean, default: false },
    truncate: { type: Boolean, default: false },
    icon: { type: String, default: "sci-back" },
    pageMenu: { type: Boolean, default: false },
    defaultBack: { type: Object as () => Location },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const goBack = h(
      GoBack,
      {
        class: "page-title__icon mr-3",
        props: { defaultRoute: ctx.props.defaultBack },
        on: ctx.listeners.click ? { click: ctx.listeners.click } : {},
      },
      [ctx.props.icon]
    );
    const baseTitle = h(BaseTitle, { class: [ctx.props.truncate ? "truncate-ellipsis" : ""] }, [
      ctx.scopedSlots.default && ctx.scopedSlots.default({}),
    ]);
    const appendSlot = ctx.scopedSlots["append"] && ctx.scopedSlots["append"]({});
    const pageMenuSlot = ctx.scopedSlots["page-menu"] && ctx.scopedSlots["page-menu"]({});
    const baseMenu = (children: ScopedSlotChildren) => h(BaseMenu, { class: "page-menu mr-n2" }, [children]);

    const pageMenuTemplate = ctx.props.pageMenu
      ? baseMenu(pageMenuSlot)
      : h("div", { class: "ml-auto" }, [pageMenuSlot]);

    return h(
      "div",
      {
        staticClass: "page-title",
        class: [
          ...(Array.isArray(ctx.data.class) ? ctx.data.class : [ctx.data.class]),
          ctx.data.staticClass,
          ctx.props.hideBorder ? "" : "__with-border",
        ],
      },
      [!ctx.props.hideBack && goBack, baseTitle, appendSlot, ctx.scopedSlots["page-menu"] && pageMenuTemplate]
    );
  },
});
